import React, { useState, useEffect } from 'react';
import Counter from './Counter.jsx';
import PostCard from './PostCard.jsx';

/**
 * Main App Component
 * This is the root React component that can be used in your Ghost theme
 */
function App({ initialMessage = 'Hello from React!' }) {
    const [message, setMessage] = useState(initialMessage);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
        console.log('React App mounted successfully!');
    }, []);

    return (
        <div className="react-app" style={{ padding: '20px' }}>
            <h2>{message}</h2>
            {isLoaded && (
                <div>
                    <p style={{ color: '#15171A', marginBottom: '20px' }}>
                        ✅ React is working in your Ghost theme!
                    </p>
                    
                    <div style={{ marginBottom: '30px' }}>
                        <h3>Example: Counter Component</h3>
                        <Counter />
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <h3>Example: Post Card Component</h3>
                        <PostCard 
                            title="Sample Ghost Post"
                            excerpt="This is an example of a React component that could display Ghost posts."
                            author="React Dev"
                            date="2025-11-04"
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default App;
